function clearUser(context) {
	context.commit('clearUser');
}

function toggleLoading(context, value) {
	context.commit('toggleLoading', value);
}

function showSnackBar(context, snackbar) {
	const visibleSnackBar = { ...snackbar };
	visibleSnackBar.isVisible = true;
	visibleSnackBar.color = visibleSnackBar.color || 'primary';
	context.commit('showSnackBar', visibleSnackBar);
}

function setToken(context, token) {
	context.commit('setToken', token);
}

function setUser(context, user) {
	context.commit('setUser', user);
	context.commit('isEmployee', user.flagAdmin);
}

function setSideBarRoutes({ commit }, routes) {
	commit('SET_SIDE_BAR_ROUTES', routes);
}

const methods = {
	clearUser,
	setSideBarRoutes,
	setToken,
	setUser,
	showSnackBar,
	toggleLoading,
};

export default methods;



// WEBPACK FOOTER //
// ./src/store/actions.js